import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	courses: [],
	webinarsandEvents: [],
	podcasts: [],
	presentations: [],
	governanceUpdates: [],
};

// active account slice
export const allShareholderEducationSlice = createSlice({
	name: 'shareholderEducation',
	initialState,
	reducers: {
		setAllCourses: (state, action) => {
			state.courses = action.payload;
		},
		setAllCoursesList: (state, action) => {
			state.coursesList = action.payload;
		},
		setAllCoursesCategories: (state, action) => {
			state.coursesCategories = action.payload;
		},
		setAllCoursesCategoriesList: (state, action) => {
			state.coursesCategoriesList = action.payload;
		},
		setAllWebinarsandEvents: (state, action) => {
			state.webinarsandEvents = action.payload;
		},
		setAllQuizzes: (state, action) => {
			state.quizzes = action.payload;
		},
		setAllPodcasts: (state, action) => {
			state.podcasts = action.payload;
		},
		setAllPresentations: (state, action) => {
			state.presentations = action.payload;
		},
		setAllGovernanceUpdates: (state, action) => {
			state.governanceUpdates = action.payload;
		},
	},
});

export const {
	setAllCourses,
	setAllCoursesList,
	setAllCoursesCategories,
	setAllCoursesCategoriesList,
	setAllWebinarsandEvents,
	setAllQuizzes,
	setAllPodcasts,
	setAllPresentations,
	setAllGovernanceUpdates,
} = allShareholderEducationSlice.actions;

export default allShareholderEducationSlice.reducer;
